import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';

@Component({
  selector: 'app-external-link-content',
  templateUrl: './external-link-content.component.html',
  styleUrls: ['./external-link-content.component.scss'],
})

export class ExternalLinkContentComponent  {

  public title:string = "";
  public iFrameURL:any;
  private url:string;
  public isIOSApp:boolean;

  constructor(
    public viewCtrl: ModalController, 
    public sanitizer: DomSanitizer,
    public navParams: NavParams,
    public platform: Platform,
    public appLinks: AppLinksService,
    )
    {
      this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
      this.title = this.navParams.data.title ? this.navParams.data.title : "";
      this.url = this.navParams.data.url;
      if(this.url) {
        this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
      } else {
        this.iFrameURL = null;
      }
    }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  openOutline() {
    this.appLinks.openInNewWindow( this.url );
  }
}